import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import dayjs from 'dayjs';
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    FormControlLabel,
    Checkbox,
    Snackbar,
    IconButton,
    InputAdornment,
    Select,
    MenuItem,
    InputLabel,
    FormControl
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import { useParams } from 'react-router-dom';
import Header1 from '../Header/Header1';




const API_URL = process.env.REACT_APP_API_URL;

const AdminCreateAccounts = ({ userId }) => {
   

    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
      }, []);



    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        admin_id:userId,
        email: '',
        phone: '',
        
    });

    const [errors, setErrors] = useState({});
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Clear the error for the specific field when the user starts typing
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Reset error for the current field
        }));

        setFormData({
            ...formData,
            [name]: value,
        });
    };

   

    const validate = () => {
        let newErrors = {};
        if (!formData.name) {
            newErrors.name = 'First Name is required';
        } else if (formData.name.length > 20) {
            newErrors.name = 'First Name cannot exceed 20 characters';
        }

        if (!formData.surname) {
            newErrors.surname = 'Last Name is required';
        } else if (formData.surname.length > 20) {
            newErrors.surname = 'Last Name cannot exceed 20 characters';
        }

    
        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else {
            // Email format validation
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|gov)$/;
            if (!emailRegex.test(formData.email)) {
                newErrors.email = 'Please enter a valid email address';
            }
        }
        const phoneRegex = /^\d{10}$/;

        if (!formData.phone) {
            newErrors.phone = 'Phone number is required';
        } else if (!phoneRegex.test(formData.phone)) {
            newErrors.phone = 'Please enter a valid 10-digit phone number';
        }
      
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (validate()) {
            await handlePost();
        } else {
            setSnackbarMessage('Account creation failed. Please check the errors and try again.');
            setSnackbarOpen(true);
        }
    };

    const handlePost = async () => {
        try {
            
            const response = await axios.post(`${API_URL}/admin_created_users/`, formData);
            showAlert()
            
        } catch (error) {
            console.error('Error posting data:', error);
            setSnackbarMessage('Failed to create account. Please try again later.');
            setSnackbarOpen(true);
        }
    };

   

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const showAlert = () => {
        const alertDiv = document.createElement('div');
        alertDiv.textContent = 'Account Created successfully';
        alertDiv.style.position = 'fixed';
        alertDiv.style.top = '10px';
        alertDiv.style.left = '50%';
        alertDiv.style.transform = 'translateX(-50%)';
        alertDiv.style.padding = '10px 20px';
        alertDiv.style.backgroundColor = 'green';
        alertDiv.style.color = 'white';
        alertDiv.style.borderRadius = '5px';
        alertDiv.style.zIndex = '9999';
        alertDiv.style.fontSize = '16px';

        document.body.appendChild(alertDiv);

        // Auto remove the alert after 3 seconds
        setTimeout(() => {
            alertDiv.remove();
        }, 3000);
    };

    return (
        <div>
            <Header1/>
            <Container
                maxWidth="lg"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100vh',
                    backgroundColor: '#000000',
                    marginTop: 5,
                    padding: { xs: '1rem', sm: '2rem', md: '3rem' } // Adjust padding for different screen sizes
                }}
            >
                <Box
                    sx={{
                        backdropFilter: 'blur(15px)',
                        backgroundColor: '#000000',
                        borderRadius: '16px',
                        padding: '1.5rem',
                        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        maxWidth: '500px',
                        textAlign: 'center',
                        width: { xs: '100%', sm: '80%', md: '60%' },
                        '&:hover': {
                            borderColor: '#1E90FF',
                        },
                    }}
                >
                    <img
                        src={Logo}
                        alt="Logo"
                        style={{
                            marginBottom: '20px',
                            height: 'auto',
                            width: '100%',
                            maxWidth: '400px',
                        }}
                    />
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{
                            color: 'white',
                            marginBottom: 2,
                            letterSpacing: 5,
                            '&:hover': {
                                color: '#1E90FF',
                            },
                        }}
                    >
                        Create an Account
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="First Name"
                            name="name"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.name}
                            onChange={handleChange}
                            error={!!errors.name}
                            helperText={errors.name}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />
                        <TextField
                            label="Last Name"
                            name="surname"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.surname}
                            onChange={handleChange}
                            error={!!errors.surname}
                            helperText={errors.surname}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />

                    

                        <TextField
                            label="Email"
                            name="email"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.email}
                            onChange={handleChange}
                            error={!!errors.email}
                            helperText={errors.email}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />
                        <TextField
                            label="Contact Number"
                            name="phone"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.phone}
                            onChange={handleChange}
                            error={!!errors.phone}
                            helperText={errors.phone}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />

                       

                        

                     

                        <Button
                            variant="contained"
                            type="submit"
                            fullWidth
                            sx={{ mt: 2, letterSpacing: 4, }}
                            
                        >
                            Create Account
                        </Button>
                    </form>

                  
                </Box>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={() => setSnackbarOpen(false)}
                    message={snackbarMessage}
                    action={
                        <IconButton size="small" onClick={() => setSnackbarOpen(false)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                />
            </Container>
            <IconButton
                onClick={scrollToTop}
                sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
                <ArrowUpwardIcon />
            </IconButton>
            <Footer2 />
        </div>
    );
};

export default AdminCreateAccounts;
